module.exports = __webpack_public_path__ + "img/etape2.138da178.png";